// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/brand/Logo.tsx  (PLAN11 WP11-07, D11-26)
// The Mindario wordmark and mark as inline SVG. Colours are token classes (no hex): the letters follow `text-ink` through
// `fill-ink`; the chevrons are `fill-brand` at 100 / 60 / 30 % opacity. The accessible name is passed in (the locale id
// common.product-name resolves in the component that owns the copy); the paths are decorative.
import { cx } from "../cx.js";
import { MARK, WORDMARK } from "./paths.js";

export type LogoTone = "auto" | "on-dark" | "on-light";
const LETTERS: Record<LogoTone, string> = { auto: "fill-ink", "on-dark": "fill-band-ink", "on-light": "fill-paper-ink" };
const CHEVRON_OPACITY = ["opacity-100", "opacity-60", "opacity-30"] as const;

export interface LogoSvgProps {
  geometry: typeof WORDMARK | typeof MARK;
  label: string;
  tone?: LogoTone;
  className?: string;
  "data-testid"?: string;
}

export function LogoSvg({ geometry, label, tone = "auto", className, "data-testid": testId }: LogoSvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={geometry.viewBox} role="img" aria-label={label} className={cx("block w-auto shrink-0", className)} data-testid={testId}>
      <path className={LETTERS[tone]} d={geometry.letters} aria-hidden="true" />
      {geometry.chevrons.map((points, i) => (
        <polygon key={points} className={cx("fill-brand", CHEVRON_OPACITY[i])} points={points} aria-hidden="true" />
      ))}
    </svg>
  );
}
